import { Grid } from '@mui/material';
import React from 'react';
import RsvpRequests from '../../components/Reservations/ViewReservations/RsvpRequests';

const RsvpRequestsPage = () => {
    return (
        <Grid
            sx={{
                width: '100%',
                height: '100%',
                justifyContent: 'left',
                alignItems: 'flex-start',
            }}
        >
            <RsvpRequests />
        </Grid>
    );
};

export default RsvpRequestsPage;
